import { styled } from '@mui/material';

import { useMemo } from 'react';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';
import { useAppContext } from '@app-velocity/config';
import { useI18n } from '@app-velocity/i18n';
import { useCurrentUser } from '@app-velocity/libs/auth';
import { Button, TeamTypeBadge, Tooltip, Typography } from '@app-velocity/ui';

export type TeamInfoProps = {
  activeTeam: TCurrentUserTeamDto;
};

const TooltipContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const TeamInfo = ({ activeTeam }: TeamInfoProps) => {
  const { t } = useI18n();
  const { AVMLink } = useAppContext();
  const currentUser = useCurrentUser();
  const simulationsInfo = useMemo(() => {
    return t('teams:simulations_left', {
      count: activeTeam.simulationLimit || 0,
    });
  }, [activeTeam, currentUser, t]);

  const appraisalsInfo = useMemo(() => {
    return t('teams:appraisals_left', {
      count: activeTeam.appraisalsLeft || 0,
    });
  }, [activeTeam, currentUser, t]);

  return (
    <Tooltip
      title={
        <TooltipContainer>
          <div>
            <Typography>{simulationsInfo}</Typography>
            <Typography>{appraisalsInfo}</Typography>
          </div>
          {activeTeam.subscriptionTier === 'FREE' ? (
            <Button
              size="small"
              variant="cta"
              color="primary"
              component="a"
              target="_blank"
              rel="noopener noreferrer"
              href={`${AVMLink}?action=subscription`}
            >
              {t('payments:upgrade')}
            </Button>
          ) : null}
        </TooltipContainer>
      }
    >
      <TeamTypeBadge tier={activeTeam.subscriptionTier} />
    </Tooltip>
  );
};
